import {checkoutOrder} from './checkout-order-de.i18n';

export const de = {
  checkoutOrder,
};
